module.exports = __webpack_public_path__ + "static/me-b7939d73d32cb3ce5e48a80dd35dc599.gif";